import React, { useRef, useEffect, useState } from "react";
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";

export default function FiltroPines({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const filtroRef = useRef(null);

  // ============================
  //        ESTADOS (rehidratables)
  // ============================

  const [cliente, setCliente] = useState(
    initialFilters.clienteId
      ? {
          id: initialFilters.clienteId,
          nombre: initialFilters.clienteNombre ?? "",
        }
      : null
  );

  const [nroPin, setNroPin] = useState(
    initialFilters.numero ?? ""
  );

  const [nroResponsable, setNroResponsable] = useState(
    initialFilters.numeroResponsable ?? ""
  );

  const [responsable, setResponsable] = useState(
    initialFilters.descripcionResponsable ?? ""
  );

  const [cedula, setCedula] = useState(
    initialFilters.numeroDocumento ?? ""
  );

  const [estadoId, setEstadoId] = useState(
    initialFilters.estadoId ?? ""
  );

  // ============================
  //   CERRAR CLICK FUERA / ESC
  // ============================
  useEffect(() => {
    const outside = (event) => {
      if (filtroRef.current && !filtroRef.current.contains(event.target)) {
        onClose();
      }
    };

    const esc = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // ============================
  //        SUBMIT
  // ============================
  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit({
      numero: nroPin ? Number(nroPin) : null,
      clienteId: cliente?.id ?? null,
      clienteNombre: cliente?.nombre ?? null, // solo UI
      numeroResponsable: nroResponsable ? Number(nroResponsable) : null,
      descripcionResponsable: responsable.trim() || null,
      numeroDocumento: cedula.trim() || null,
      estadoId: estadoId || null,
    });
  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          {/* Nro de PIN */}
          <div>
            <label className="form-label-fil">Nro de PIN</label>
            <input
              type="text"
              className="input"
              value={nroPin}
              onChange={(e) => setNroPin(e.target.value)}
            />
          </div>

          {/* Cliente */}
          <div>
            <label className="form-label-fil">Cliente</label>
            <ClienteAutocomplete
              value={cliente}
              onChange={setCliente}
              placeholder="Buscar cliente..."
            />
          </div>

          {/* Nro Responsable */}
          <div>
            <label className="form-label-fil">Nro. Responsable</label>
            <input
              type="text"
              className="input"
              value={nroResponsable}
              onChange={(e) => setNroResponsable(e.target.value)}
            />
          </div>

          {/* Responsable */}
          <div>
            <label className="form-label-fil">Responsable</label>
            <input
              type="text"
              className="input"
              value={responsable}
              onChange={(e) => setResponsable(e.target.value)}
            />
          </div>

          {/* Cédula */}
          <div>
            <label className="form-label-fil">Cédula</label>
            <input
              type="text"
              className="input"
              value={cedula}
              onChange={(e) => setCedula(e.target.value)}
            />
          </div>

          {/* Estado */}
          <div>
            <label className="form-label-fil">Estado</label>
            <select
              className="input"
              value={estadoId}
              onChange={(e) => setEstadoId(e.target.value)}
            >
              <option value="">-- Todos --</option>
              <option value="14">PIN ACTIVO</option>
              <option value="15">PIN INACTIVO</option>
            </select>
          </div>

          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
